import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sellerServices } from '../services/seller.service';
import { toast } from 'react-hot-toast';

export const useVerifyKycDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sellerServices.verifyKycDocument,
    onSuccess: (data, variables) => {
      toast.success('KYC document verified successfully');
      queryClient.invalidateQueries({ queryKey: ['seller', variables.sellerId] });
      queryClient.invalidateQueries({ queryKey: ['sellers'] });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to verify KYC document');
    },
  });
};
